import { SlashLg, Camera as Photograph } from "react-bootstrap-icons";
import { getEnvironmentCameraSettings } from "../util/utils";
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';

export function CameraToggleButton(props) {
	let {isCameraActive, setIsCameraActive} = props;

	let toggleCameraAction = () => {
		setIsCameraActive(!isCameraActive);
	};

	// NOTE - setting this to onClick sometimes causes the action to repeat - not sure why - so I set it to onMouseUp
	return <button className="float-end camera_button" onMouseUp={toggleCameraAction} style={{position: "relative"}}>
		<Photograph style={{width:"2em", height:"2em"}} />
		{isCameraActive && <SlashLg color="red" style={{width: "2em", height: "2em", position: "absolute", left: "0.3em", top: "0.45em"}} />}
	</button>;
}

export function CameraPhotoList(props) {
	let {isCameraActive, receivePhotoDataAction, deletePhotoAction, photoList} = props;
	let cameraSettings = getEnvironmentCameraSettings();

	return <>
		{isCameraActive && <div>
			<Camera onTakePhoto={receivePhotoDataAction} idealFacingMode={FACING_MODES.ENVIRONMENT} isImageMirror={cameraSettings.needsMirroring}></Camera>
		</div>}
		<div className="photo-list">
			{ (photoList || []).map((ph, idx) => <div width="30%" className="float-start mt-2 me-2" style={{position: "relative", width:"30%"}} key={ph.id}>
				<img src={ph.url || ph.photoData} style={{width:"100%"}} />
				<button className="deletePhoto" onClick={deletePhotoAction(ph)} style={{position: "absolute", top:"0", right:"0"}}>X</button>
			</div>) }
			<div className="clearfix"></div>
		</div>
	</>;
}